/*** Constant for login user */
export const LOGIN_USER_DATA_REQUEST = "LOGIN_USER_DATA_REQUEST";
export const LOGIN_USER_DATA_SUCCESS = "LOGIN_USER_DATA_SUCCESS";
export const LOGIN_USER_DATA_FAILURE = "LOGIN_USER_DATA_FAILURE";

/*** constant for Jwt Token */
export const JWT_TOKEN = "JWT_TOKEN";

//constant for chat messages
export const CHAT_MESSAGE = "CHAT_MESSAGE";

/*** Broadcast file upload */
export const BROADCAST_FILE_DATA_REQUEST = "BROADCAST_FILE_DATA_REQUEST";
export const BROADCAST_FILE_DATA_SUCCESS = "BROADCAST_FILE_DATA_SUCCESS";
export const BROADCAST_FILE_DATA_FAILURE = "BROADCAST_FILE_DATA_FAILURE";
//const for active users
export const ACTIVE_PATIENTS_REQUEST = "ACTIVE_PATIENTS_REQUEST";
export const ACTIVE_PATIENTS_SUCCESS = "ACTIVE_PATIENTS_SUCCESS";
export const ACTIVE_PATIENTS_FAILURE = "ACTIVE_PATIENTS_FAILURE";

//const for active users
export const UNCLAIMED_PATIENTS_REQUEST = "UNCLAIMED_PATIENTS_REQUEST";
export const UNCLAIMED_PATIENTS_SUCCESS = "UNCLAIMED_PATIENTS_SUCCESS";
export const UNCLAIMED_PATIENTS_FAILURE = "UNCLAIMED_PATIENTS_FAILURE";

//const for QUEUED users
export const QUEUED_PATIENTS_REQUEST = "QUEUED_PATIENTS_REQUEST";
export const QUEUED_PATIENTS_SUCCESS = "QUEUED_PATIENTS_SUCCESS";
export const QUEUED_PATIENTS_FAILURE = "QUEUED_PATIENTS_FAILURE";

//const for active users
export const OTHER_PATIENTS_REQUEST = "OTHER_PATIENTS_REQUEST";
export const OTHER_PATIENTS_SUCCESS = "OTHER_PATIENTS_SUCCESS";
export const OTHER_PATIENTS_FAILURE = "OTHER_PATIENTS_FAILURE";

//const for patient message
export const BROADCAST_MESSAGE_REQUEST = "BROADCAST_MESSAGE_REQUEST";
export const BROADCAST_MESSAGE_SUCCESS = "BROADCAST_MESSAGE_SUCCESS";
export const BROADCAST_MESSAGE_FAILURE = "BROADCAST_MESSAGE_FAILURE";

//const for old chat per userId and patientId,
export const LOAD_CHAT_USER_ID_PATIENT_ID_REQUEST =
  "LOAD_CHAT_USER_ID_PATIENT_ID_REQUEST";
export const LOAD_CHAT_USER_ID_PATIENT_ID_SUCCESS =
  "LOAD_CHAT_USER_ID_PATIENT_ID_SUCCESS";
export const LOAD_CHAT_USER_ID_PATIENT_ID_FAILURE =
  "LOAD_CHAT_USER_ID_PATIENT_ID_FAILURE";

//const for claimed patient by the user
export const CLAIMED_PATIENT_BY_USER_REQUEST =
  "CLAIMED_PATIENT_BY_USER_REQUEST";
export const CLAIMED_PATIENT_BY_USER_SUCCESS =
  "CLAIMED_PATIENT_BY_USER_SUCCESS";
export const CLAIMED_PATIENT_BY_USER_FAILURE =
  "CLAIMED_PATIENT_BY_USER_FAILURE";

//const for revoke patient by the user
export const REVOKE_PATIENT_BY_USER_REQUEST = "REVOKE_PATIENT_BY_USER_REQUEST";
export const REVOKE_PATIENT_BY_USER_SUCCESS = "REVOKE_PATIENT_BY_USER_SUCCESS";
export const REVOKE_PATIENT_BY_USER_FAILURE = "REVOKE_PATIENT_BY_USER_FAILURE";

// const for send upload link to patient by the user
export const SEND_UPLOAD_LINK_BY_USER_REQUEST =
  "SEND_UPLOAD_LINK_BY_USER_REQUEST";
export const SEND_UPLOAD_LINK_BY_USER_SUCCESS =
  "SEND_UPLOAD_LINK_BY_USER_SUCCESS";
export const SEND_UPLOAD_LINK_BY_USER_FAILURE =
  "SEND_UPLOAD_LINK_BY_USER_FAILURE";

// const for upload patient files by the patient
export const UPLOAD_PATIENT_FILES_BY_PATIENT_REQUEST =
  "UPLOAD_PATIENT_FILES_BY_PATIENT_REQUEST";
export const UPLOAD_PATIENT_FILES_BY_PATIENT_SUCCESS =
  "UPLOAD_PATIENT_FILES_BY_PATIENT_SUCCESS";
export const UPLOAD_PATIENT_FILES_BY_PATIENT_FAILURE =
  "UPLOAD_PATIENT_FILES_BY_PATIENT_FAILURE";

// const for send document signing link
export const SEND_DOC_SIGN_LINK_REQUEST = "SEND_DOC_SIGN_LINK_REQUEST";
export const SEND_DOC_SIGN_LINK_SUCCESS = "SEND_DOC_SIGN_LINK_SUCCESS";
export const SEND_DOC_SIGN_LINK_FAILURE = "SEND_DOC_SIGN_LINK_FAILURE";

// const for download patient files by user
export const DOWNLOAD_PATIENT_FILES_BY_USER_REQUEST =
  "DOWNLOAD_PATIENT_FILES_BY_USER_REQUEST";
export const DOWNLOAD_PATIENT_FILES_BY_USER_SUCCESS =
  "DOWNLOAD_PATIENT_FILES_BY_USER_SUCCESS";
export const DOWNLOAD_PATIENT_FILES_BY_USER_FAILURE =
  "DOWNLOAD_PATIENT_FILES_BY_USER_FAILURE";

// const for download patient signed document by user
export const DOWNLOAD_SIGNED_DOC_BY_USER_REQUEST =
  "DOWNLOAD_PATIENT_FILES_BY_USER_REQUEST";
export const DOWNLOAD_SIGNED_DOC_BY_USER_SUCCESS =
  "DOWNLOAD_SIGNED_DOC_BY_USER_SUCCESS";
export const DOWNLOAD_SIGNED_DOC_BY_USER_FAILURE =
  "DOWNLOAD_SIGNED_DOC_BY_USER_FAILURE";

//const for shifting active patients
export const SHIFT_ACTIVE_PATIENTS_LIST = "SHIFT_ACTIVE_PATIENTS_LIST";
//const for reordering unclaimed patients
export const REORDER_UNCLIAMED_PATIENT_LIST = "REORDER_UNCLIAMED_PATIENT_LIST";
//update read status message for user ,only for backend status update.
export const UPDATE_MESSAGE_STATUS_API_CALL = "UPDATE_MESSAGE_STATUS_API_CALL";
//const for updating other patients
export const UPDATE_OTHER_PATIENT_LIST = "UPDATE_OTHER_PATIENT_LIST";
//const for save count all types of patient
export const SAVE_PATIENT_COUNT = "SAVE_PATIENT_COUNT";
//const for save notifications
export const SAVE_NOTIFICATION_COUNT = "SAVE_NOTIFICATION_COUNT";

export const REORDER_UNCLAIMED_PATIENTS_SAGA_TYPE =
  "REORDER_UNCLAIMED_PATIENTS_SAGA_TYPE";

  export const REORDER_QUEUED_PATIENTS_SAGA_TYPE =
  "REORDER_QUEUED_PATIENTS_SAGA_TYPE";

//const for liveAgent chat
export const LIVE_AGENT_CHAT_REQUEST = "LIVE_AGENT_CHAT_REQUEST";
export const LIVE_AGENT_CHAT_SUCCESS = "LIVE_AGENT_CHAT_SUCCESS";
export const LIVE_AGENT_CHAT_FAILURE = "LIVE_AGENT_CHAT_FAILURE";

//save chat count of all tabs for liveAgent
export const SAVE_CHAT_COUNT = "SAVE_CHAT_COUNT";

//const for revoke client by the agent
export const REVOKE_PATIENT_BY_AGENT_REQUEST =
  "REVOKE_PATIENT_BY_AGENT_REQUEST";
export const REVOKE_PATIENT_BY_AGENT_SUCCESS =
  "REVOKE_PATIENT_BY_AGENT_SUCCESS";
export const REVOKE_PATIENT_BY_AGENT_FAILURE =
  "REVOKE_PATIENT_BY_AGENT_FAILURE";

//const for claimed chat by the agent
export const CLAIM_CHAT_BY_AGENT_REQUEST = "CLAIM_CHAT_BY_AGENT_REQUEST";
export const CLAIM_CHAT_BY_AGENT_SUCCESS = "CLAIM_CHAT_BY_AGENT_SUCCESS";
export const CLAIM_CHAT_BY_AGENT_FAILURE = "CLAIM_CHAT_BY_AGENT_FAILURE";

//const for shifting chat list
export const SHIFT_CHAT_LIST = "SHIFT_CHAT_LIST";
